<template>
    <syain-file-disp />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import FileDisp from '@/components/syain/FileDisp.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'syain-file-disp': FileDisp
    }
})
</script>
